<template>
  <div class="courese-unit">
    <lr-link
      class="course-unit"
      :to="videoHrefObj.url"
      :target="videoHrefObj.target"
    >
      <h1
        class="courese-unit-title ellipsis"
        v-html="highlightFormat(courseData.post_title, keyword)"
      ></h1>
    </lr-link>
    <div class="courese-unit-box">
      <lr-link
        class="course-unit"
        :to="videoHrefObj.url"
        :target="videoHrefObj.target"
      >
        <!-- <img class="courese-unit-cover" :src="courseData.thumbnail" /> -->
        <div class="courese-unit-cover">
          <img class="cover" :src="bgImg" />
          <h3
            class="title ellipsis-2"
            :class="titleClass"
            v-html="videoTitle"
          ></h3>
          <img class="play" src="./images/ic-play.svg" />
        </div>
      </lr-link>
      <div class="courese-unit-detail">
        <div
          class="courese-unit-detail-content"
          v-html="
            highlightFormat(
              ellipsisString(courseData.post_excerpt, 102),
              keyword
            )
          "
        ></div>
        <div class="courese-unit-detail-expand">
          <span>{{ postTypeNameMap[courseData.post_type] }}</span>
          <span v-if="courseData.post_type !== '2'">
            {{ topCateNameMap[courseData.top_cate] }}
          </span>
          <span><img src="./images/time.svg" />{{ videoTime }}</span>
          <span>{{ courseData.post_hits | crowd }}已学</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getmmss,
  jpkUrlHandler,
  highlightFormat,
  getCourseBackgroundTitle,
  getCourseBackgroundUrl,
  getCourseBackgroundType,
  ellipsisString,
} from '@/common/utils';
import { POST_TYPE_NAME_MAP, TOP_CATE_NAME_MAP } from '@/common/constant';
export default {
  props: {
    courseData: {
      type: Object,
      default: () => {},
    },
    keyword: {
      type: String,
      default: '',
    },
  },
  computed: {
    // 展示的视频时长
    videoTime() {
      const { courseData } = this;
      if (courseData.total_time) return courseData.total_time;

      if (courseData.time) return courseData.time;

      if (courseData.post_video && courseData.post_video.time) {
        return getmmss(courseData.post_video.time);
      }

      return '';
    },
    // 视频跳转的链接
    videoHrefObj() {
      const { courseData } = this;

      let url = '';
      let target = '_blank';

      if (courseData.status === 0) {
        url = 'javascript:;';
        target = '_self';
      } else if (courseData.url) {
        if (courseData.url.includes('//edu.wps.cn')) {
          url = jpkUrlHandler(courseData.url, 'wps_xy_pagetab');
        } else {
          url = courseData.url;
        }
      } else if (courseData.post_id || courseData.id) {
        url = `/learning/course/detail/id/${
          courseData.post_id || courseData.id
        }`;
      }
      return { url, target };
    },
    // 标题的class
    titleClass() {
      const { coverImg } = this;
      if (coverImg.indexOf('single') !== -1) {
        return 'max';
      } else if (coverImg.indexOf('jpk_') !== -1) {
        return 'jpk';
      }

      return '';
    },
    // 处理标题的展示内容
    videoTitle() {
      return getCourseBackgroundTitle(this.courseData);
    },
    // 复刻学院原有逻辑
    coverImg() {
      const { unitCover, courseData } = this;

      if (unitCover) {
        return unitCover;
      }

      return getCourseBackgroundType(courseData);
    },
    // 展示的背景图
    bgImg() {
      const { coverImg } = this;
      return getCourseBackgroundUrl(coverImg);
    },
  },
  data() {
    return {
      postTypeNameMap: POST_TYPE_NAME_MAP,
      topCateNameMap: TOP_CATE_NAME_MAP,
    };
  },
  methods: {
    highlightFormat,
    ellipsisString,
  },
};
</script>

<style lang="scss" scoped>
.courese-unit {
  width: 720px;

  &-title {
    font-weight: 600;
    color: #222226;
    font-size: 18px;
    line-height: 25px;
    margin-bottom: 10px;

    &:hover {
      color: #417ff9;
    }
  }

  &-box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &-cover {
    width: 192px;
    height: 108px;
    margin-right: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .cover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .play {
      width: 36px;
      height: 36px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -15px;
      margin-top: -15px;
      z-index: 5;
    }

    .title {
      position: relative;
      position: relative;
      z-index: 1;
      max-width: 192px;
      max-height: 60px;
      font-size: 16px;
      font-weight: 700;
      line-height: 1.5;
      color: #ffffff;

      &.max {
        max-width: 192px;
        text-align: center;
      }

      &.jpk {
        width: 192px;
        max-width: 192px;
        text-align: left;
        padding-right: 60px;
        line-height: 1.4;
      }
    }
  }

  &-detail {
    flex: 1;
    box-sizing: border-box;
    height: 108px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    &-content {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      display: block;
      font-size: 14px;
      color: #222226;
      line-height: 20px;
      height: 60px;
      word-break: break-all;
    }
    &-expand {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      span {
        font-weight: 400;
        color: #888888;
        font-size: 12px;
        margin-right: 30px;
        height: 17px;
        line-height: 17px;
        display: flex;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
